<section *ngIf="data" class="simple-table">
	<ng-container *ngFor="let row of data.cells; index as i">
		<section
			*ngIf="(data?.headersY)[i]?.config?.visible"
			class="row text-14 align-items-center"
			[ngClass]="{ striped: isStriped, 'group-member': (data?.headersY)[i]?.attribute?.isGroupMember }"
			[class.minimal]="data?.headersX?.length === 1"
		>
			<ng-container>
				<span class="col text-sm-14-bold" [ngClass]="categoryColumnClass">
					<icon
						*ngIf="(data?.headersY)[i]?.attribute?.iconType && !colors"
						[style.fill]="(data?.headersY)[i]?.attribute?.colorTheme || DEFAULT_COLOR_THEME"
						class="pull-left category-icon"
						[type]="(data?.headersY)[i]?.attribute?.iconType"
					></icon>
					<icon
						*ngIf="(data?.headersY)[i]?.attribute?.iconType && colors"
						[style.fill]="colors[i]"
						class="pull-left category-icon"
						[type]="(data?.headersY)[i]?.attribute?.iconType"
					></icon>
					<span class="icon-caption" [ngClass]="{ 'sub-category text-sm-14': (data?.headersY)[i]?.parent }">{{ data.headersY[i].formattedValue }}</span>
				</span>
			</ng-container>
		</section>
	</ng-container>
</section>

<ng-template #notApplicable> <span class="col text-align-right" [ngClass]="dataColumnClass">n/a</span> </ng-template>
